import { useMemo, type FC } from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import FilterButtons from 'app/KinerjaShared/components/FilterButtons'

import type {
  PerencanaanKsByDinasState,
  PerencanaanKsByDinasTipe,
  PerencanaanKsByDinasTipeCounts,
} from 'types/kinerja-ks'

export type FilterItem = PerencanaanKsByDinasState | PerencanaanKsByDinasTipe

export type AdditionalFilterItem = {
  label: string
  value: FilterItem[]
  isTipe: true
}

type FilterItemObj = {
  label: string
  value: FilterItem[]
  isTipe?: boolean
}

type FilterItems = FilterItemObj[]

type Props = {
  isLoading?: boolean
  counts: Record<PerencanaanKsByDinasState, number>
  additionalFilters?: AdditionalFilterItem[]
  tipeCounts?: PerencanaanKsByDinasTipeCounts
  activeFilter?: Array<FilterItem>
  onChange?: (value: Array<FilterItem>) => void
}

export const FilterStatusSubmission: FC<Props> = ({
  isLoading,
  counts,
  additionalFilters,
  tipeCounts,
  activeFilter,
  onChange,
}) => {
  const filterItems: FilterItems = useMemo(() => {
    const tipeCounterMap: Record<PerencanaanKsByDinasTipe, number | undefined> =
      {
        SPF: tipeCounts?.SPF ?? 0,
        SPNF: tipeCounts?.SPNF ?? 0,
      }

    const items: FilterItemObj[] = [
      { value: ['ALL'], label: 'Semua' },
      ...(additionalFilters ?? []),
      { value: ['READY'], label: 'Sudah dikumpulkan' },
      { value: ['DRAFT'], label: 'Belum dikumpulkan' },
    ]

    return items.map((item: FilterItemObj) => {
      const label = item?.label

      let counter: number | null = null
      if (item.isTipe) {
        const count = tipeCounterMap[item.value[0] as PerencanaanKsByDinasTipe]
        counter = tipeCounts ? count ?? 0 : null
      } else if (!!counts) {
        counter = item?.value?.reduce((acc, curr) => {
          return acc + (counts?.[curr as PerencanaanKsByDinasState] || 0)
        }, 0)
      }

      return {
        ...item,
        label: `${label}${
          counter !== null && counter >= 0 ? ` (${counter})` : ''
        }`,
      }
    })
  }, [counts, additionalFilters, tipeCounts])

  return (
    <div>
      {isLoading && (
        <div className="flex gap-4">
          {Array.from({ length: 4 })?.map((_, index) => (
            <Shimmer
              width={90 + index * 20}
              height={38}
              className="!rounded-full"
              key={index}
            />
          ))}
        </div>
      )}

      {!isLoading && (
        <FilterButtons<FilterItem[]>
          items={filterItems}
          activeValue={activeFilter}
          btnSize="md"
          onChange={(value) => onChange?.(value)}
        />
      )}
    </div>
  )
}
